/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiDetectionBoundingBoxFromJSON, StreemApiDetectionBoundingBoxToJSON, } from './';
export function StreemApiDetectionFromJSON(json) {
    return StreemApiDetectionFromJSONTyped(json, false);
}
export function StreemApiDetectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'detectionSid': !exists(json, 'detection_sid') ? undefined : json['detection_sid'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'confidence': !exists(json, 'confidence') ? undefined : json['confidence'],
        'boundingBox': !exists(json, 'bounding_box') ? undefined : StreemApiDetectionBoundingBoxFromJSON(json['bounding_box']),
        'source': !exists(json, 'source') ? undefined : json['source'],
        'hidden': !exists(json, 'hidden') ? undefined : json['hidden'],
        'extractor': !exists(json, 'extractor') ? undefined : json['extractor'],
        'lastUpdatedAt': !exists(json, 'last_updated_at') ? undefined : (new Date(json['last_updated_at'])),
    };
}
export function StreemApiDetectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'detection_sid': value.detectionSid,
        'type': value.type,
        'description': value.description,
        'confidence': value.confidence,
        'bounding_box': StreemApiDetectionBoundingBoxToJSON(value.boundingBox),
        'source': value.source,
        'hidden': value.hidden,
        'extractor': value.extractor,
        'last_updated_at': value.lastUpdatedAt === undefined ? undefined : (value.lastUpdatedAt.toISOString()),
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiDetectionType;
(function (StreemApiDetectionType) {
    StreemApiDetectionType["FULLTEXT"] = "DETECTION_TYPE_FULL_TEXT";
    StreemApiDetectionType["INVALID"] = "DETECTION_TYPE_INVALID";
    StreemApiDetectionType["LABEL"] = "DETECTION_TYPE_LABEL";
    StreemApiDetectionType["LOGO"] = "DETECTION_TYPE_LOGO";
    StreemApiDetectionType["MODEL"] = "DETECTION_TYPE_MODEL";
    StreemApiDetectionType["OBJECT"] = "DETECTION_TYPE_OBJECT";
    StreemApiDetectionType["SAFESEARCH"] = "DETECTION_TYPE_SAFE_SEARCH";
    StreemApiDetectionType["SERIAL"] = "DETECTION_TYPE_SERIAL";
    StreemApiDetectionType["TEXT"] = "DETECTION_TYPE_TEXT";
})(StreemApiDetectionType || (StreemApiDetectionType = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiDetectionSource;
(function (StreemApiDetectionSource) {
    StreemApiDetectionSource["AUTO"] = "DETECTION_SOURCE_AUTO";
    StreemApiDetectionSource["INVALID"] = "DETECTION_SOURCE_INVALID";
    StreemApiDetectionSource["OCR"] = "DETECTION_SOURCE_OCR";
    StreemApiDetectionSource["USER"] = "DETECTION_SOURCE_USER";
})(StreemApiDetectionSource || (StreemApiDetectionSource = {}));
//# sourceMappingURL=StreemApiDetection.js.map